import { useEffect, useState } from 'react'

import ActivityWrapper from '~/bootcamp/Activities/components/ActivityWrapper'
import { ActivityProps, Slice } from '~/bootcamp/Activities/types/activities.types'

import FractionsActivityWrapper from '~/bootcamp/Activities/Fractions/components/FractionsActivityWrapper'

import { CircleWithSlice } from '~/bootcamp/Activities/Fractions/components/CircleWithSlice/CircleWithSlice'

import Divider from '~/bootcamp/Activities/components/Divider'

import { useEmitInstance } from '~/bootcamp/Activities/utils/instance.utils'

import { generateTerms } from './helpers'
import { getRangesByDifficulty } from './constants'

function Clicking({
  answerState,
  difficultyLevel,
  onNextQuestionClick,
  onAnswerStateChange,
  onInstanceChange,
  actionButtonsFC,
}: ActivityProps): React.ReactElement {
  const [answer, setAnswer] = useState(false)
  const [numOfNumerator, setNumOfNumerator] = useState<number>(0)
  const [numOfDenominator, setNumOfDenominator] = useState<number>(2)
  const [sliceData, setSliceData] = useState<Slice[]>([])
  const [taskHistory, setTaskHistory] = useState<number[]>([])
  // A real round can equal the placeholder values, so gate the emit on the generator having run.
  const [ready, setReady] = useState(false)

  const { resetHistory } = getRangesByDifficulty(difficultyLevel)

  useEffect(() => {
    setAnswer(true)
    const [numerator, denominator] = generateTerms(difficultyLevel, taskHistory)
    setNumOfNumerator(numerator)
    setNumOfDenominator(denominator)
    setReady(true)
  }, [difficultyLevel, taskHistory])

  // Slotless: the student clicks that many slices, so sliceData.isColored stays out.
  useEmitInstance(onInstanceChange, ready ? `\\frac{${numOfNumerator}}{${numOfDenominator}}` : null)

  useEffect(() => {
    onAnswerStateChange(null)
  }, [answer, onAnswerStateChange])

  const handleOnCheckAnswerClick = (): void => {
    const isCorrect = sliceData.filter((item) => item.isColored === true).length === numOfNumerator
    onAnswerStateChange(isCorrect)
  }

  const handleOnNextQuestionClick = (): void => {
    setTaskHistory((prevState) => {
      return [numOfDenominator, ...prevState].slice(0, resetHistory)
    })
    onAnswerStateChange(null)
    onNextQuestionClick()
  }

  const toggleColorsCallback = (data: Slice[]): void => {
    setSliceData(data)
  }

  return (
    <ActivityWrapper>
      <FractionsActivityWrapper>
        <CircleWithSlice
          isWrong={answerState === false}
          numOfDenominator={numOfDenominator}
          numOfNumerator={0}
          toggleColorAction={toggleColorsCallback}
        />
        <div className="w-6 flex flex-col items-center ml-5">
          {numOfNumerator}
          <Divider />
          {numOfDenominator}
        </div>
      </FractionsActivityWrapper>
      {actionButtonsFC &&
        actionButtonsFC({
          formValid: answer !== false,
          correctAnswer: answerState ?? false,
          submitAnswerAction: handleOnCheckAnswerClick,
          clearFormAction: () => setAnswer(true),
          goToNextQuestionAction: handleOnNextQuestionClick,
        })}
    </ActivityWrapper>
  )
}

export default Clicking
